import api from '@pray/shared/utils/api';

import type { ExperimentInstanceResponse } from './types/api';

/**
 * Returns all experiment instances
 * @returns The experiment instances
 */
export async function getExperimentInstances() {
  const url = '/web/studio/experiment-instances';

  const response = await api.executeGetRequest<ExperimentInstanceResponse>(url);

  return response.data;
}
